// extracted by mini-css-extract-plugin
module.exports = {"Header":"Menubar-module--Header--3yT4Y","Focus":"Menubar-module--Focus--27Tkx","blink":"Menubar-module--blink--L2IX2"};